import React from "react";
import {
  CardComp,
  ModalCompAdvanceUpdate,
  TabsComp,
} from "../../../components";
import FilterFind from "../../../components/FilterFind";
import LoanRepaymentComp from "./modules/LoanRepaymentComp";
import LoanRepaymentRecord from "./LoanRepaymentRecord";
import {
  useGetDueRepaymentQuery,
  useGetLoanBreakdownByLoanRequestIdQuery,
  useGetOverdueRepaymentQuery,
  useGetUpcomingRepaymentQuery,
} from "../../../store/admin/loanRepayment";
import { useNavigate } from "react-router-dom";

/**
 * The list rows do not say whether the loan allows part payments or what it still owes, so ask the loan
 * itself before showing the form (the amount box starts from what it finds).
 */
function RecordLoanForRow({ Back, loanRepaymentDetails }) {
  const { data, isLoading } = useGetLoanBreakdownByLoanRequestIdQuery(
    loanRepaymentDetails?.loan_request_id,
    { skip: !loanRepaymentDetails?.loan_request_id }
  );

  if (isLoading) {
    return (
      <div className="py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <LoanRepaymentRecord
      Back={Back}
      loanRepaymentDetails={loanRepaymentDetails}
      partialEnabled={Boolean(data?.partial_repayment_enabled)}
      loanOutstanding={data?.outstanding_balance}
      lateFeeBalance={data?.late_fee_balance}
    />
  );
}

export default function LoanRepayment() {
  const navigate = useNavigate();
  const [modalPage, setModalPage] = React.useState("");
  const [loanRepaymentDetails, setLoanRepaymentDetails] = React.useState("");
  const [upcomingRepaymentPage, setUpcomingRepaymentPage] = React.useState(1);
  const [dueRepaymentPage, setDueRepaymentPage] = React.useState(1);
  const [overdueRepaymentPage, setOverdueRepaymentPage] = React.useState(1);
  const {
    data: upcomingRepayments,
    isLoading: isLoadingUpcomingRepayments,
    isFetching: isFetchingUpcomingRepayments,
  } = useGetUpcomingRepaymentQuery(upcomingRepaymentPage);

  const {
    data: dueRepayments,
    isLoading: isLoadingDueRepayments,
    isFetching: isFetchingDueRepayments,
  } = useGetDueRepaymentQuery(dueRepaymentPage);

  const {
    data: overdueRepayments,
    isLoading: isLoadingOverdueRepayments,
    isFetching: isFetchingOverdueRepayments,
  } = useGetOverdueRepaymentQuery(overdueRepaymentPage);

  const useModal = [
    {
      name: "Record Loan",
      component: (
        <RecordLoanForRow
          Back={() => setModalPage()}
          loanRepaymentDetails={loanRepaymentDetails}
        />
      ),
    },
  ];
  const getTableDropDown = (row) => {
    const TableDropDown = [
      {
        name: "Record loan",
        action: (data) => {
          setLoanRepaymentDetails(row);
          setModalPage("Record Loan");
        },
      },
    ];
    return TableDropDown;
  };

  const useTab = [
    {
      name: "Upcoming repayment",
      component: (
        <LoanRepaymentComp
          title={"Loan Status"}
          getTableDropDown={getTableDropDown}
          TableData={upcomingRepayments?.data?.company_loan_requests || []}
          pagination={upcomingRepayments?.data?.pagination}
          setPageNumber={setUpcomingRepaymentPage}
          loading={isLoadingUpcomingRepayments || isFetchingUpcomingRepayments}
          name={"upcoming repayments"}
        />
      ),
    },
    {
      name: "Due repayment",
      component: (
        <LoanRepaymentComp
          title={"Loan Status"}
          getTableDropDown={getTableDropDown}
          TableData={dueRepayments?.data?.company_loan_requests || []}
          pagination={dueRepayments?.data?.pagination}
          setPageNumber={setDueRepaymentPage}
          loading={isLoadingDueRepayments || isFetchingDueRepayments}
          name={"due repayments"}
        />
      ),
    },
    {
      name: "Overdue repayment",
      component: (
        <LoanRepaymentComp
          title={"Loan Status"}
          dateClassName="bg-danger2"
          getTableDropDown={getTableDropDown}
          TableData={overdueRepayments?.data?.company_loan_requests || []}
          pagination={overdueRepayments?.data?.pagination}
          setPageNumber={setOverdueRepaymentPage}
          loading={isLoadingOverdueRepayments || isFetchingOverdueRepayments}
          name={"overdue repayments"}
        />
      ),
    },
  ];

  return (
    <section className=" px-lg-3 min-vh-100 mb-3">
      <FilterFind rightSide={false} title={"Loan Repayment "} />

      <CardComp>
        <div className="py-4"></div>
        <TabsComp
          TabArray={useTab}
          input="name"
          justifyContent={"justify-content-start"}
          tabClassName="px-0"
          TabArrayClassName="px-4"
          btn
          btnOnClick={() =>
            navigate("/super_admin/loan_management/repayment_by_member")
          }
          btnWrapper={" w-[12.5rem]"}
        />
      </CardComp>
      <ModalCompAdvanceUpdate
        pageName={modalPage}
        arrayComp={useModal}
        handleClose={() => setModalPage()}
        centered
        size={"lg"}
      />
    </section>
  );
}
